import React from 'react';
import {
	convertToSolidRGBA,
	isLightweightColor,
} from '../../utils/helper/Helper';

export const Sidemenwicons = {
	tapverse_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 10V8m0 10.667a4.667 4.667 0 0 1-4.667-4.666v-4a4.667 4.667 0 1 1 9.334 0v4A4.667 4.667 0 0 1 12 18.667"
			></path>
		</svg>
	),
	tapverse: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 10V8m0 10.667a4.667 4.667 0 0 1-4.667-4.666v-4a4.667 4.667 0 1 1 9.334 0v4A4.667 4.667 0 0 1 12 18.667"
			></path>
		</svg>
	),
	insight: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12" cy="12" r="12" fill="#E8FFF6" fill-opacity="0.1" />
			<g clip-path="url(#clip0_11820_51840)">
				<path
					d="M15.4666 13.3338C15.6513 13.3338 15.7436 13.3338 15.8185 13.3748C15.8802 13.4086 15.9377 13.4721 15.9652 13.5369C15.9985 13.6155 15.9901 13.6991 15.9733 13.8662C15.8864 14.7329 15.5881 15.5681 15.1012 16.2968C14.5151 17.1739 13.6822 17.8575 12.7076 18.2611C11.7331 18.6648 10.6607 18.7704 9.62617 18.5646C8.5916 18.3588 7.64129 17.8509 6.89541 17.105C6.14953 16.3591 5.64158 15.4088 5.43579 14.3743C5.23001 13.3397 5.33562 12.2673 5.73929 11.2928C6.14296 10.3183 6.82655 9.4853 7.70361 8.89927C8.43236 8.41233 9.26748 8.11404 10.1342 8.02708C10.3014 8.01031 10.3849 8.00192 10.4635 8.03525C10.5283 8.06274 10.5918 8.1202 10.6256 8.18194C10.6666 8.25678 10.6666 8.34911 10.6666 8.53377V12.8004C10.6666 12.9871 10.6666 13.0805 10.703 13.1518C10.7349 13.2145 10.7859 13.2655 10.8487 13.2974C10.92 13.3338 11.0133 13.3338 11.2 13.3338H15.4666Z"
					stroke={
						isLightweightColor(`var(--primary-base-color)`)
							? convertToSolidRGBA(`var(--primary-base-color)`)
							: '#ffffff'
					}
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M13.3333 5.86711C13.3333 5.68244 13.3333 5.5901 13.3743 5.51527C13.4081 5.45353 13.4717 5.39607 13.5365 5.36858C13.615 5.33525 13.6986 5.34363 13.8658 5.3604C15.0847 5.48267 16.2307 6.02197 17.1045 6.89587C17.9784 7.76976 18.5178 8.91571 18.64 10.1346C18.6568 10.3018 18.6652 10.3854 18.6318 10.464C18.6043 10.5288 18.5469 10.5923 18.4852 10.6261C18.4103 10.6671 18.318 10.6671 18.1333 10.6671L13.8666 10.6671C13.68 10.6671 13.5866 10.6671 13.5153 10.6308C13.4526 10.5988 13.4016 10.5478 13.3696 10.4851C13.3333 10.4138 13.3333 10.3205 13.3333 10.1338V5.86711Z"
					stroke="white"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_11820_51840">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(4 4)"
					/>
				</clipPath>
			</defs>
		</svg>
	),
	insight_fade: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12" cy="12" r="12" fill="#E8FFF6" fill-opacity="0.1" />
			<g clip-path="url(#clip0_11820_51840)">
				<path
					d="M15.4666 13.3338C15.6513 13.3338 15.7436 13.3338 15.8185 13.3748C15.8802 13.4086 15.9377 13.4721 15.9652 13.5369C15.9985 13.6155 15.9901 13.6991 15.9733 13.8662C15.8864 14.7329 15.5881 15.5681 15.1012 16.2968C14.5151 17.1739 13.6822 17.8575 12.7076 18.2611C11.7331 18.6648 10.6607 18.7704 9.62617 18.5646C8.5916 18.3588 7.64129 17.8509 6.89541 17.105C6.14953 16.3591 5.64158 15.4088 5.43579 14.3743C5.23001 13.3397 5.33562 12.2673 5.73929 11.2928C6.14296 10.3183 6.82655 9.4853 7.70361 8.89927C8.43236 8.41233 9.26748 8.11404 10.1342 8.02708C10.3014 8.01031 10.3849 8.00192 10.4635 8.03525C10.5283 8.06274 10.5918 8.1202 10.6256 8.18194C10.6666 8.25678 10.6666 8.34911 10.6666 8.53377V12.8004C10.6666 12.9871 10.6666 13.0805 10.703 13.1518C10.7349 13.2145 10.7859 13.2655 10.8487 13.2974C10.92 13.3338 11.0133 13.3338 11.2 13.3338H15.4666Z"
					stroke={
						isLightweightColor(`var(--primary-base-color)`)
							? convertToSolidRGBA(`var(--primary-base-color)`)
							: 'rgba(204, 204, 204, .6)'
					}
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M13.3333 5.86711C13.3333 5.68244 13.3333 5.5901 13.3743 5.51527C13.4081 5.45353 13.4717 5.39607 13.5365 5.36858C13.615 5.33525 13.6986 5.34363 13.8658 5.3604C15.0847 5.48267 16.2307 6.02197 17.1045 6.89587C17.9784 7.76976 18.5178 8.91571 18.64 10.1346C18.6568 10.3018 18.6652 10.3854 18.6318 10.464C18.6043 10.5288 18.5469 10.5923 18.4852 10.6261C18.4103 10.6671 18.318 10.6671 18.1333 10.6671L13.8666 10.6671C13.68 10.6671 13.5866 10.6671 13.5153 10.6308C13.4526 10.5988 13.4016 10.5478 13.3696 10.4851C13.3333 10.4138 13.3333 10.3205 13.3333 10.1338V5.86711Z"
					stroke={
						isLightweightColor(`var(--primary-base-color)`)
							? convertToSolidRGBA(`var(--primary-base-color)`)
							: 'rgba(204, 204, 204, .6)'
					}
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
		</svg>
	),
	repayment: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<circle cx="12" cy="12" r="12" fill="#E8FFF6" fillOpacity="0.1"></circle>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M18.667 9.666H5.333m0 2.667h2.365c.36 0 .54 0 .714.03q.232.042.45.137c.161.07.311.17.61.37l.388.259c.3.2.45.3.612.37q.217.094.45.136c.173.031.353.031.713.031h.73c.36 0 .54 0 .714-.031q.232-.042.449-.136c.162-.07.312-.17.611-.37l.388-.259c.3-.2.45-.3.612-.37q.216-.095.449-.136c.174-.031.354-.031.714-.031h2.365M5.333 8.799v6.4c0 .747 0 1.12.146 1.406.127.25.331.454.582.582.286.146.659.146 1.406.146h9.066c.747 0 1.12 0 1.406-.146.25-.128.454-.331.582-.582.146-.285.146-.659.146-1.406V8.8c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H7.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405"
			></path>
		</svg>
	),
	repayment_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<circle cx="12" cy="12" r="12" fill="#E8FFF6" fillOpacity="0.1"></circle>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M18.667 9.666H5.333m0 2.667h2.365c.36 0 .54 0 .714.03q.232.042.45.137c.161.07.311.17.61.37l.388.259c.3.2.45.3.612.37q.217.094.45.136c.173.031.353.031.713.031h.73c.36 0 .54 0 .714-.031q.232-.042.449-.136c.162-.07.312-.17.611-.37l.388-.259c.3-.2.45-.3.612-.37q.216-.095.449-.136c.174-.031.354-.031.714-.031h2.365M5.333 8.799v6.4c0 .747 0 1.12.146 1.406.127.25.331.454.582.582.286.146.659.146 1.406.146h9.066c.747 0 1.12 0 1.406-.146.25-.128.454-.331.582-.582.146-.285.146-.659.146-1.406V8.8c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H7.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405"
			></path>
		</svg>
	),
	overviewIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5.333 11.334h5.334m-3.322-9.49L2.824 5.36c-.303.235-.454.353-.563.5-.096.13-.168.277-.212.433C2 6.47 2 6.661 2 7.043v4.824c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h7.734c.746 0 1.12 0 1.405-.146.25-.128.455-.332.583-.582.145-.286.145-.66.145-1.406V7.044c0-.383 0-.574-.05-.75a1.3 1.3 0 0 0-.211-.434c-.11-.147-.26-.265-.563-.5L8.655 1.843c-.234-.182-.351-.273-.48-.308a.67.67 0 0 0-.35 0c-.129.035-.246.126-.48.308"
			></path>
		</svg>
	),
	overviewIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5.333 11.334h5.334m-3.322-9.49L2.824 5.36c-.303.235-.454.353-.563.5-.096.13-.168.277-.212.433C2 6.47 2 6.661 2 7.043v4.824c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h7.734c.746 0 1.12 0 1.405-.146.25-.128.455-.332.583-.582.145-.286.145-.66.145-1.406V7.044c0-.383 0-.574-.05-.75a1.3 1.3 0 0 0-.211-.434c-.11-.147-.26-.265-.563-.5L8.655 1.843c-.234-.182-.351-.273-.48-.308a.67.67 0 0 0-.35 0c-.129.035-.246.126-.48.308"
			></path>
		</svg>
	),
	merchantIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5 7.333H3.067c-.374 0-.56 0-.703.073a.67.67 0 0 0-.291.291C2 7.84 2 8.027 2 8.4V14m9-6.667h1.933c.374 0 .56 0 .703.073a.67.67 0 0 1 .291.291c.073.143.073.33.073.703V14m-3 0V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C9.987 2 9.613 2 8.867 2H7.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C5 3.013 5 3.387 5 4.133V14m9.667 0H1.333m6-9.333h1.334M7.333 7.333h1.334M7.333 10h1.334"
			></path>
		</svg>
	),
	merchantIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5 7.333H3.067c-.374 0-.56 0-.703.073a.67.67 0 0 0-.291.291C2 7.84 2 8.027 2 8.4V14m9-6.667h1.933c.374 0 .56 0 .703.073a.67.67 0 0 1 .291.291c.073.143.073.33.073.703V14m-3 0V4.133c0-.746 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583C9.987 2 9.613 2 8.867 2H7.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C5 3.013 5 3.387 5 4.133V14m9.667 0H1.333m6-9.333h1.334M7.333 7.333h1.334M7.333 10h1.334"
			></path>
		</svg>
	),
	transactionIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M4.667 2.666v10.667m0 0L2 10.666m2.667 2.667 2.666-2.667m4 2.667V2.666m0 0L8.667 5.333m2.666-2.667L14 5.333"
			></path>
		</svg>
	),
	transactionIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M4.667 2.666v10.667m0 0L2 10.666m2.667 2.667 2.666-2.667m4 2.667V2.666m0 0L8.667 5.333m2.666-2.667L14 5.333"
			></path>
		</svg>
	),
	feeIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.333 1.514v2.753c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h2.754m-2.487 3.333H5.333m5.334 2.667H5.333m1.334-5.333H5.333m4-4.667H5.867c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v6.933c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.427.218-.988.218-2.108V5.334z"
			></path>
		</svg>
	),
	feeIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.333 1.514v2.753c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h2.754m-2.487 3.333H5.333m5.334 2.667H5.333m1.334-5.333H5.333m4-4.667H5.867c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v6.933c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.427.218-.988.218-2.108V5.334z"
			></path>
		</svg>
	),
	terminalIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 6V2.4c0-.373 0-.56-.073-.702a.67.67 0 0 0-.29-.291c-.144-.073-.33-.073-.704-.073H5.067c-.374 0-.56 0-.703.073a.67.67 0 0 0-.291.291C4 1.841 4 2.028 4 2.401V6m2.667-2v-.667m2.666.667v-.667M5.867 14.667h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.427.218-.988.218-2.108V8.134c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v3.333c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218"
			></path>
		</svg>
	),
	terminalIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 6V2.4c0-.373 0-.56-.073-.702a.67.67 0 0 0-.29-.291c-.144-.073-.33-.073-.704-.073H5.067c-.374 0-.56 0-.703.073a.67.67 0 0 0-.291.291C4 1.841 4 2.028 4 2.401V6m2.667-2v-.667m2.666.667v-.667M5.867 14.667h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.427.218-.988.218-2.108V8.134c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H4.8c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.658-.145 1.405v3.333c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218"
			></path>
		</svg>
	),
	billsIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M10 1.334v.933c0 .374 0 .56-.073.703a.67.67 0 0 1-.291.291c-.143.073-.33.073-.703.073H7.067c-.374 0-.56 0-.703-.073a.67.67 0 0 1-.291-.291C6 2.827 6 2.64 6 2.267v-.933m-.533 13.333h5.066c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.658.146-1.405V3.467c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H5.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405v9.067c0 .747 0 1.12.146 1.405.127.251.331.455.582.583.285.145.659.145 1.406.145"
			></path>
		</svg>
	),
	billsIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M10 1.334v.933c0 .374 0 .56-.073.703a.67.67 0 0 1-.291.291c-.143.073-.33.073-.703.073H7.067c-.374 0-.56 0-.703-.073a.67.67 0 0 1-.291-.291C6 2.827 6 2.64 6 2.267v-.933m-.533 13.333h5.066c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.658.146-1.405V3.467c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H5.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405v9.067c0 .747 0 1.12.146 1.405.127.251.331.455.582.583.285.145.659.145 1.406.145"
			></path>
		</svg>
	),
	reqIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M1.667 8H3.92c.457 0 .875.257 1.079.666s.622.667 1.079.667H9.92c.457 0 .875-.258 1.079-.667a1.21 1.21 0 0 1 1.079-.667h2.254M5.978 2.666h4.044c.718 0 1.077 0 1.394.11a2 2 0 0 1 .747.461c.24.235.4.556.721 1.198l1.445 2.889c.126.252.189.378.233.51q.06.176.085.36c.02.138.02.279.02.56v1.379c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H4.533c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V8.755c0-.282 0-.423.02-.56a2 2 0 0 1 .085-.361c.044-.132.107-.258.233-.51l1.444-2.89c.322-.641.482-.962.722-1.197a2 2 0 0 1 .747-.462c.317-.109.676-.109 1.394-.109"
			></path>
		</svg>
	),
	reqIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M1.667 8H3.92c.457 0 .875.257 1.079.666s.622.667 1.079.667H9.92c.457 0 .875-.258 1.079-.667a1.21 1.21 0 0 1 1.079-.667h2.254M5.978 2.666h4.044c.718 0 1.077 0 1.394.11a2 2 0 0 1 .747.461c.24.235.4.556.721 1.198l1.445 2.889c.126.252.189.378.233.51q.06.176.085.36c.02.138.02.279.02.56v1.379c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H4.533c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V8.755c0-.282 0-.423.02-.56a2 2 0 0 1 .085-.361c.044-.132.107-.258.233-.51l1.444-2.89c.322-.641.482-.962.722-1.197a2 2 0 0 1 .747-.462c.317-.109.676-.109 1.394-.109"
			></path>
		</svg>
	),
	settlementIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.667 3.333c0 .737-1.642 1.334-3.667 1.334S1.333 4.07 1.333 3.333m7.334 0C8.667 2.597 7.025 2 5 2s-3.667.597-3.667 1.333m7.334 0v2.972c-.815.244-1.334.614-1.334 1.028m-6-4v8c0 .737 1.642 1.334 3.667 1.334.886 0 1.7-.115 2.333-.305V7.333M1.333 6c0 .736 1.642 1.333 3.667 1.333.886 0 1.7-.114 2.333-.304m-6 1.638C1.333 9.403 2.975 10 5 10c.886 0 1.7-.114 2.333-.305m7.334-2.362c0 .737-1.642 1.334-3.667 1.334S7.333 8.07 7.333 7.333m7.334 0C14.667 6.597 13.025 6 11 6s-3.667.597-3.667 1.333m7.334 0v5.334C14.667 13.403 13.025 14 11 14s-3.667-.597-3.667-1.333V7.333M14.667 10c0 .736-1.642 1.333-3.667 1.333S7.333 10.736 7.333 10"
			></path>
		</svg>
	),
	settlementIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.667 3.333c0 .737-1.642 1.334-3.667 1.334S1.333 4.07 1.333 3.333m7.334 0C8.667 2.597 7.025 2 5 2s-3.667.597-3.667 1.333m7.334 0v2.972c-.815.244-1.334.614-1.334 1.028m-6-4v8c0 .737 1.642 1.334 3.667 1.334.886 0 1.7-.115 2.333-.305V7.333M1.333 6c0 .736 1.642 1.333 3.667 1.333.886 0 1.7-.114 2.333-.304m-6 1.638C1.333 9.403 2.975 10 5 10c.886 0 1.7-.114 2.333-.305m7.334-2.362c0 .737-1.642 1.334-3.667 1.334S7.333 8.07 7.333 7.333m7.334 0C14.667 6.597 13.025 6 11 6s-3.667.597-3.667 1.333m7.334 0v5.334C14.667 13.403 13.025 14 11 14s-3.667-.597-3.667-1.333V7.333M14.667 10c0 .736-1.642 1.333-3.667 1.333S7.333 10.736 7.333 10"
			></path>
		</svg>
	),
	complianceIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M7.535 14.41c.147.086.221.13.325.152a.8.8 0 0 0 .28 0c.104-.023.178-.066.325-.152 1.3-.758 4.868-3.137 4.868-6.41V4.812c0-.533 0-.8-.087-1.029a1.33 1.33 0 0 0-.364-.526c-.184-.162-.434-.255-.933-.443l-3.574-1.34c-.139-.052-.208-.078-.28-.088a.7.7 0 0 0-.19 0c-.072.01-.14.036-.28.088l-3.574 1.34c-.499.188-.749.281-.932.443a1.33 1.33 0 0 0-.365.526c-.087.23-.087.496-.087 1.029V8c0 3.273 3.57 5.653 4.868 6.41"
			></path>
		</svg>
	),
	complianceIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M7.535 14.41c.147.086.221.13.325.152a.8.8 0 0 0 .28 0c.104-.023.178-.066.325-.152 1.3-.758 4.868-3.137 4.868-6.41V4.812c0-.533 0-.8-.087-1.029a1.33 1.33 0 0 0-.364-.526c-.184-.162-.434-.255-.933-.443l-3.574-1.34c-.139-.052-.208-.078-.28-.088a.7.7 0 0 0-.19 0c-.072.01-.14.036-.28.088l-3.574 1.34c-.499.188-.749.281-.932.443a1.33 1.33 0 0 0-.365.526c-.087.23-.087.496-.087 1.029V8c0 3.273 3.57 5.653 4.868 6.41"
			></path>
		</svg>
	),
	disputeIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5.75 5.75h4.5m-4.5 3h2.624M14 8c0 .863-.182 1.683-.51 2.424L14 13.999l-3.064-.766A6 6 0 1 1 13.999 8"
			></path>
		</svg>
	),
	disputeIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M5.75 5.75h4.5m-4.5 3h2.624M14 8c0 .863-.182 1.683-.51 2.424L14 13.999l-3.064-.766A6 6 0 1 1 13.999 8"
			></path>
		</svg>
	),
	settingsIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
			></path>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m6.193 12.915.39.876a1.475 1.475 0 0 0 2.696 0l.39-.876a1.62 1.62 0 0 1 1.646-.95l.954.102a1.475 1.475 0 0 0 1.348-2.335l-.565-.775a1.62 1.62 0 0 1-.306-.956c0-.343.108-.676.31-.953l.564-.776a1.474 1.474 0 0 0-1.348-2.334l-.954.101a1.617 1.617 0 0 1-1.647-.953L9.28 2.21a1.475 1.475 0 0 0-2.696 0l-.39.877a1.62 1.62 0 0 1-1.647.952l-.956-.101a1.475 1.475 0 0 0-1.348 2.335l.564.775a1.62 1.62 0 0 1 0 1.905l-.564.776a1.474 1.474 0 0 0 1.348 2.335l.954-.102a1.62 1.62 0 0 1 1.65.953"
			></path>
		</svg>
	),
	settingsIcon_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
			></path>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m6.193 12.915.39.876a1.475 1.475 0 0 0 2.696 0l.39-.876a1.62 1.62 0 0 1 1.646-.95l.954.102a1.475 1.475 0 0 0 1.348-2.335l-.565-.775a1.62 1.62 0 0 1-.306-.956c0-.343.108-.676.31-.953l.564-.776a1.474 1.474 0 0 0-1.348-2.334l-.954.101a1.617 1.617 0 0 1-1.647-.953L9.28 2.21a1.475 1.475 0 0 0-2.696 0l-.39.877a1.62 1.62 0 0 1-1.647.952l-.956-.101a1.475 1.475 0 0 0-1.348 2.335l.564.775a1.62 1.62 0 0 1 0 1.905l-.564.776a1.474 1.474 0 0 0 1.348 2.335l.954-.102a1.62 1.62 0 0 1 1.65.953"
			></path>
		</svg>
	),
	settlementHistory: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<g clipPath="url(#clip0_9603_31425)">
				<path
					stroke={
						isLightweightColor(`var(--primary-base-color)`)
							? convertToSolidRGBA(`var(--primary-base-color)`)
							: '#ffffff'
					}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="0.8"
					d="m1.333 8 6.428 3.214a.7.7 0 0 0 .178.075.3.3 0 0 0 .122 0 .7.7 0 0 0 .177-.075L14.667 8M1.333 11.334l6.428 3.214c.088.043.132.065.178.074q.061.012.122 0c.046-.009.09-.03.177-.074l6.429-3.214M1.333 4.667l6.428-3.214a.7.7 0 0 1 .178-.074.3.3 0 0 1 .122 0c.046.008.09.03.177.074l6.429 3.214-6.429 3.214a.7.7 0 0 1-.177.074.3.3 0 0 1-.122 0 .7.7 0 0 1-.178-.074z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_9603_31425">
					<path fill="#fff" d="M0 0h16v16H0z"></path>
				</clipPath>
			</defs>
		</svg>
	),
	settlementHistory_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<g clipPath="url(#clip0_9603_31425)">
				<path
					stroke={
						isLightweightColor(`var(--primary-base-color)`)
							? convertToSolidRGBA(`var(--primary-base-color)`)
							: 'rgba(204, 204, 204, .6)'
					}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="0.8"
					d="m1.333 8 6.428 3.214a.7.7 0 0 0 .178.075.3.3 0 0 0 .122 0 .7.7 0 0 0 .177-.075L14.667 8M1.333 11.334l6.428 3.214c.088.043.132.065.178.074q.061.012.122 0c.046-.009.09-.03.177-.074l6.429-3.214M1.333 4.667l6.428-3.214a.7.7 0 0 1 .178-.074.3.3 0 0 1 .122 0c.046.008.09.03.177.074l6.429 3.214-6.429 3.214a.7.7 0 0 1-.177.074.3.3 0 0 1-.122 0 .7.7 0 0 1-.178-.074z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_9603_31425">
					<path fill="#fff" d="M0 0h16v16H0z"></path>
				</clipPath>
			</defs>
		</svg>
	),
	settlementAccountChnage: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: '#ffffff'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.8"
				d="M3.333 6v5.333m3-5.334v5.334m3.334-5.334v5.334m3-5.334v5.334M2 12.399v.534c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h9.866c.374 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292c.073-.142.073-.329.073-.702v-.534c0-.373 0-.56-.073-.702a.67.67 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072H3.067c-.374 0-.56 0-.703.072a.67.67 0 0 0-.291.292C2 11.839 2 12.026 2 12.399M7.769 2.051 2.835 3.147c-.298.066-.447.1-.558.18a.67.67 0 0 0-.223.277C2 3.73 2 3.883 2 4.188v.745c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h9.866c.374 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292C14 5.493 14 5.306 14 4.933v-.745c0-.305 0-.458-.054-.584a.67.67 0 0 0-.223-.277c-.111-.08-.26-.114-.558-.18L8.23 2.051a1.4 1.4 0 0 0-.173-.033 1 1 0 0 0-.116 0 1.4 1.4 0 0 0-.173.033"
			></path>
		</svg>
	),
	settlementAccountChnage_fade: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<path
				stroke={
					isLightweightColor(`var(--primary-base-color)`)
						? convertToSolidRGBA(`var(--primary-base-color)`)
						: 'rgba(204, 204, 204, .6)'
				}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.8"
				d="M3.333 6v5.333m3-5.334v5.334m3.334-5.334v5.334m3-5.334v5.334M2 12.399v.534c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h9.866c.374 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292c.073-.142.073-.329.073-.702v-.534c0-.373 0-.56-.073-.702a.67.67 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072H3.067c-.374 0-.56 0-.703.072a.67.67 0 0 0-.291.292C2 11.839 2 12.026 2 12.399M7.769 2.051 2.835 3.147c-.298.066-.447.1-.558.18a.67.67 0 0 0-.223.277C2 3.73 2 3.883 2 4.188v.745c0 .373 0 .56.073.702a.67.67 0 0 0 .291.292c.143.072.33.072.703.072h9.866c.374 0 .56 0 .703-.072a.67.67 0 0 0 .291-.292C14 5.493 14 5.306 14 4.933v-.745c0-.305 0-.458-.054-.584a.67.67 0 0 0-.223-.277c-.111-.08-.26-.114-.558-.18L8.23 2.051a1.4 1.4 0 0 0-.173-.033 1 1 0 0 0-.116 0 1.4 1.4 0 0 0-.173.033"
			></path>
		</svg>
	),
};

export const DashboardIcon = {
	balanceIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="36"
			fill="none"
			viewBox="0 0 36 36"
			className="img"
		>
			<path
				fill="var(--primary-accent-color-one)"
				d="M25.409 9.843H5.629c-.79 0-1.429.64-1.429 1.43v12.649c0 .79.64 1.429 1.43 1.429h19.779c.79 0 1.43-.64 1.43-1.43V11.274c0-.79-.64-1.43-1.43-1.43"
			></path>
			<path
				fill="var(--primary-accent-color-one)"
				d="M20.27 8.4h-9.653a.55.55 0 0 0-.55.55v1.786c0 .304.246.55.55.55h9.653a.55.55 0 0 0 .55-.55V8.95a.55.55 0 0 0-.55-.55"
				opacity="0.81"
			></path>
			<path
				fill="var(--primary-accent-color-three)"
				d="M25.409 12.27H5.629c-.79 0-1.429.64-1.429 1.43v12.648c0 .79.64 1.43 1.43 1.43h19.779c.79 0 1.43-.64 1.43-1.43V13.7c0-.79-.64-1.43-1.43-1.43"
				style={{ mixBlendMode: 'multiply' }}
			></path>
			<path
				fill="var(--primary-accent-color-three)"
				d="M17.974 9.75h-5.89a.13.13 0 0 0-.13.129v.42c0 .071.058.13.13.13h5.89a.13.13 0 0 0 .13-.13v-.42a.13.13 0 0 0-.13-.13"
			></path>
			<g style={{ mixBlendMode: 'multiply' }}>
				<path
					fill="var(--primary-accent-color-three)"
					d="M28.153 15.993H23.75a.74.74 0 0 0-.741.742v2.668c0 .409.331.74.74.74h4.404c.41 0 .741-.331.741-.74v-2.668a.74.74 0 0 0-.74-.742"
				></path>
				<path
					stroke="var(--primary-accent-color-three)"
					strokeMiterlimit="10"
					strokeWidth="2"
					d="M28.153 15.993H23.75a.74.74 0 0 0-.741.742v2.668c0 .409.331.74.74.74h4.404c.41 0 .741-.331.741-.74v-2.668a.74.74 0 0 0-.74-.742Z"
				></path>
			</g>
			<path
				fill="var(--primary-accent-color-one)"
				d="M25.14 18.923a.854.854 0 1 0 0-1.708.854.854 0 0 0 0 1.708"
			></path>
			<path
				fill="var(--primary-accent-color-three)"
				d="m31.76 27.227-.027.032q.027-.015.027-.032"
			></path>
		</svg>
	),
	bankreqIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="36"
			fill="none"
			viewBox="0 0 36 36"
			className="img"
		>
			<path
				fill="var(--primary-base-color)"
				d="M9.932 28.05h14.134c1.015 0 1.882-.376 2.6-1.094q2.893-2.892 5.784-5.785c.458-.459.442-.928-.039-1.372-1.515-1.4-3.9-1.379-5.385.066-1.162 1.133-2.3 2.29-3.447 3.44-.475.48-1.035.72-1.713.714-1.122-.01-2.244-.003-3.366-.003-.492 0-.985.01-1.477-.007a.814.814 0 0 1-.778-1.021c.1-.376.436-.612.897-.613 1.569-.002 3.137 0 4.707-.003q.301.009.6-.045c1.004-.215 1.628-1.015 1.664-2.12.025-.73-.273-1.043-1-1.045-.692 0-1.386.015-2.079-.005-.444-.013-.906-.01-1.325-.134a10.2 10.2 0 0 1-1.85-.732c-1.77-.925-3.6-1.204-5.559-.753-1.558.36-2.371 1.317-2.371 2.907v7.605zm-1.65-8.056c-.684 0-1.339-.025-1.992.008-.414.022-.687.375-.688.817q-.006 3.188 0 6.374c0 .52.341.85.86.857.55.006 1.094.003 1.641 0q.09-.006.18-.027z"
			></path>
			<path
				fill="var(--primary-base-color)"
				d="M9.933 28.05v-7.605c0-1.59.813-2.55 2.37-2.907 1.957-.45 3.79-.172 5.56.753a10.2 10.2 0 0 0 1.85.732c.418.123.88.121 1.325.134.692.02 1.386.005 2.079.006.724 0 1.023.314 1 1.045-.037 1.104-.66 1.905-1.665 2.12q-.298.053-.6.044c-1.569.004-3.137 0-4.707.003-.46 0-.8.238-.896.613a.814.814 0 0 0 .777 1.021c.492.017.985.007 1.477.007 1.122 0 2.244-.007 3.366.003.679.007 1.239-.234 1.714-.713 1.145-1.15 2.285-2.308 3.447-3.44 1.481-1.445 3.87-1.466 5.383-.066.481.444.497.913.039 1.372l-5.785 5.785c-.717.717-1.585 1.093-2.6 1.093q-6.95.006-13.9 0z"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				d="M8.283 19.995v8.03a1 1 0 0 1-.179.026c-.547.003-1.094.006-1.641 0-.519-.005-.859-.337-.86-.857q-.008-3.188 0-6.374c0-.442.274-.795.688-.817.653-.033 1.309-.008 1.992-.008"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				stroke="#F7F7F7"
				d="M14.861 9.988a5.878 5.878 0 1 1 8.311 8.314 5.878 5.878 0 0 1-8.31-8.314Z"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				d="M19.017 20.55a6.406 6.406 0 1 1 6.405-6.405 6.41 6.41 0 0 1-6.405 6.405m0-12.755a6.35 6.35 0 1 0 6.35 6.35 6.357 6.357 0 0 0-6.35-6.35"
			></path>
		</svg>
	),
	bankdisburedIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="36"
			fill="none"
			viewBox="0 0 36 36"
			className="img"
		>
			<path
				fill="var(--primary-base-color)"
				d="M28.664 6H7.336C6.598 6 6 6.583 6 7.301v5.112c0 .719.598 1.301 1.336 1.301h21.328c.738 0 1.336-.582 1.336-1.3V7.3C30 6.583 29.402 6 28.664 6"
			></path>
			<path
				fill="var(--primary-base-color)"
				stroke="var(--primary-accent-color-one)"
				strokeMiterlimit="10"
				strokeWidth="0.833"
				d="M27.728 8.857H9.858a.357.357 0 0 0-.357.357v1.193c0 .197.16.357.357.357h17.87c.197 0 .357-.16.357-.357V9.214a.357.357 0 0 0-.357-.357Z"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				d="M11.499 9.715v18.778c0 .16.026.318.079.466s.13.283.228.396q.147.172.341.265a.9.9 0 0 0 .404.095h11.896a.9.9 0 0 0 .404-.095q.194-.093.342-.265c.097-.113.175-.248.227-.396s.08-.306.079-.466V9.715z"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				stroke="var(--primary-accent-color-one)"
				strokeWidth="1.667"
				d="M19.668 21.69v2.334h-.334V21.69z"
			></path>
			<path
				fill="var(--primary-accent-color-one)"
				d="M23.127 15.857h-1.252c-.206 0-.374.141-.374.314v8.372c0 .174.168.314.374.314h1.252c.206 0 .374-.14.374-.314v-8.372c0-.173-.168-.314-.374-.314"
			></path>
		</svg>
	),
	usersIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="36"
			fill="none"
			viewBox="0 0 36 36"
			className="img"
		>
			<path
				fill="var(--primary-base-color)"
				d="M32.413 26.57v3.23c0 .383-.336.695-.75.695H19.595c-.414 0-.75-.312-.75-.695v-3.23c0-2.324 1.25-4.209 4.54-4.209q.164.005.35.005c.537.002 1.192-.02 1.894-.029.7.01 1.357.031 1.894.029q.184.001.35-.005c3.291 0 4.54 1.885 4.54 4.21M26.077 20.984a4.335 4.335 0 1 0-1.39-8.559 4.335 4.335 0 0 0 1.39 8.559M17.155 26.57v3.23c0 .383-.336.695-.75.695H4.337c-.414 0-.75-.312-.75-.695v-3.23c0-2.324 1.25-4.209 4.54-4.209q.165.005.35.005c.537.002 1.192-.02 1.895-.029.7.01 1.357.031 1.893.029q.185 0 .35-.005c3.291 0 4.54 1.885 4.54 4.21M10.819 20.985a4.336 4.336 0 1 0-1.39-8.56 4.336 4.336 0 0 0 1.39 8.56"
			></path>
			<path
				fill="var(--primary-accent-color-two)"
				d="M26.125 26.006V29.7c0 .439-.384.795-.858.795H11.463c-.473 0-.857-.356-.857-.795v-3.694c0-2.66 1.428-4.815 5.193-4.815q.188.005.4.005c.614.004 1.363-.022 2.167-.032.803.01 1.55.036 2.166.032q.21.001.4-.005c3.765 0 5.193 2.156 5.193 4.815M18.877 19.615a4.959 4.959 0 1 0-1.59-9.79 4.959 4.959 0 0 0 1.59 9.79"
			></path>
		</svg>
	),
	bankswitchIcon: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="28"
			fill="none"
			viewBox="0 0 28 28"
			className="img"
		>
			<path
				fill="var(--primary-accent-color-two)"
				d="M7.933 22.856V12.299a1.4 1.4 0 1 0-2.8 0v10.557a1.4 1.4 0 1 0 2.8 0M13.067 23.333V10.39a1.4 1.4 0 0 0-2.8 0v12.942a1.4 1.4 0 1 0 2.8 0M17.733 23.333V10.39a1.4 1.4 0 0 0-2.8 0v12.942a1.4 1.4 0 0 0 2.8 0M22.867 22.856V12.299a1.4 1.4 0 1 0-2.8 0v10.557a1.4 1.4 0 1 0 2.8 0"
			></path>
			<path
				fill="var(--primary-base-color)"
				d="M24.267 22.825H3.734c-.124 0-.243.075-.33.21a.94.94 0 0 0-.137.505v1.431c0 .19.05.372.137.506s.206.21.33.21h20.533c.124 0 .243-.076.33-.21a.94.94 0 0 0 .137-.506v-1.43c0-.19-.05-.372-.137-.507-.087-.134-.206-.21-.33-.21M24.946 9.32 14.233 3.349a.48.48 0 0 0-.466 0L3.054 9.32a.49.49 0 0 0-.254.437v2.987c0 .132.051.258.143.352a.48.48 0 0 0 .344.145h21.426c.13 0 .253-.052.344-.145a.5.5 0 0 0 .143-.352V9.758a.51.51 0 0 0-.254-.437"
				// style={{ mixBlendMode: 'multiply' }}
			></path>
		</svg>
	),
};
